"use strict";

exports.__esModule = true;
exports.default = validateField;
function validateField(value, validations, otherValues) {
  var errors = (validations || []).reduce(function (errors, validation) {
    return errors.concat(validation(value, otherValues) || []);
  }, []);
  return errors[0] || null;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/onion-form/lib/validateField.js
// module id = 494
// module chunks = 0